import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {} from 'src/modules/SuperAdmin/store/actions/condition.action';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';
import {
  getAllFormsAction,
  updateFormsConditions,
} from 'src/modules/SuperAdmin/store/actions/formconditions.action';
import { getAllFormsSlice } from 'src/modules/SuperAdmin/store/slices/formconditions.slice';

const EditFormConditions = ({
  isOpen,
  setIsOpen,
  filterSelectedOrganizationUUID,
}) => {
  const { forms, getFormConditionById } = useSelector(
    (state) => state?.formConditionsState
  );

  const [formOptions, setFormsOptions] = useState([]);
  const [selectedOrganizationUUID, setSelectedOrganizationUUID] =
    useState(null);
  const [existingForms, setExistingForms] = useState([]);

  useEffect(() => {
    if (forms && Array.isArray(forms)) {
      let formsArr = [];
      forms.forEach((key) => {
        formsArr.push({
          value: key?.form_id,
          label: key?.form_name,
        });
      });
      setFormsOptions(formsArr);
    }
  }, [forms]);

  useEffect(() => {
    const initialFormIds = getFormConditionById?.forms.map(
      (item) => item?.form_id
    );
    setExistingForms(initialFormIds);
  }, [getFormConditionById]);

  const validationSchemaField = Yup.object().shape({
    // form_id: Yup.string().required(" "),
  });

  const dispatch = useDispatch();

  const initialValues = {
    org_uuid: getFormConditionById?.org,
    condition_id: getFormConditionById?.condition,
    form_id: existingForms,
  };

  const sections = [
    {
      heading: 'Edit form condition',
      fields: [],
    },
    {
      className: 'grid grid-cols-3 gap-4',
      fields: [
        {
          name: 'org_uuid',
          type: 'text',
          title: 'Organization name',
          placeholder: 'Select organization',
          options: [],
          disabled: true,
          onChange: (setFieldValue, e) => {
            setSelectedOrganizationUUID(e);
          },
        },
        {
          name: 'condition_id',
          type: 'text',
          title: 'Condition name',
          placeholder: 'Select condition',
          options: [],
          disabled: true,
          onChange: (setFieldValue, e) => {
            setFieldValue('condition_id', e);
            dispatch(getAllFormsAction(selectedOrganizationUUID, e));
          },
        },
        {
          name: 'form_id',
          type: 'select',
          title: 'Form type',
          placeholder: 'Select form type',
          options: formOptions,
          dropdownMode: 'multiple',
          onChange: (setFieldValue, e) => {
            setFieldValue('form_id', e);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={'feedback-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
        dispatch(getAllFormsSlice([]));
      }}
      handleSubmit={(values) => {
        const payload = {
          condition_id: getFormConditionById?.condition_id,
          form_id: values?.form_id,
          org_uuid: filterSelectedOrganizationUUID,
        };
        dispatch(updateFormsConditions(payload, setIsOpen));
      }}
    />
  );
};

export default EditFormConditions;
